export const handlePaymentMethodName = (paymentMethod: string): string => {
  if (paymentMethod === 'credito') return 'Pago Crédito Proveedor'
  if (paymentMethod === 'post-pago') return 'Pago contra entrega'
  if (paymentMethod === 'pre-pago') return 'Pago anticipado'

  return ''
}
